import classNames from 'classnames';
import Flex from 'components/common/Flex';
import SubtleBadge from 'components/common/SubtleBadge';
import PropTypes from 'prop-types';
import React from 'react';
import { CustomIcon } from 'shared/components/CustomIcon';

import classes from './NavbarVerticalMenuItem.module.scss';

const NavbarVerticalMenuItem = ({ route }) => {
  return (
    <Flex alignItems="center">
      {route.icon && (
        <span className={classNames('nav-link-icon', classes['link-icon'])}>
          <CustomIcon icon={route.icon} />
        </span>
      )}
      <span
        className={classNames(
          'nav-link-text ps-1 position-relative',
          classes['link-icon']
        )}
      >
        {route.name}
      </span>
      {route.badge && (
        <SubtleBadge
          pill
          bg={route.badge.type}
          className="justify-self-end ms-auto"
        >
          {route.badge.text}
        </SubtleBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
